"use client";
import { jsx as i } from "react/jsx-runtime";
import { useIsInverseVariant as l } from "./theme-variant-context.js";
import m from "classnames";
import { sprinkles as c } from "./sprinkles.css-mistica.js";
import { vars as r } from "./skins/skin-contract.css-mistica.js";
const d = (param)=>{
    let { width: e = "100%", height: o = 8, radius: s = r.borderRadii.container, className: a, noBorderRadius: n = !1 } = param;
    const t = l();
    return /* @__PURE__ */ i("div", {
        className: m(a, c({
            background: t ? r.colors.backgroundSkeletonInverse : r.colors.backgroundSkeleton
        })),
        style: {
            borderRadius: n ? 0 : s,
            width: e,
            height: o
        },
        "aria-hidden": !0
    });
}, v = d;
export { v as default };
